function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2024 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

import request from '@/utils/request';

/**
 * 商品详情
 * @param pram
 */
export function productDetailApi(id) {
  return request({
    url: "/admin/platform/product/info/".concat(id),
    method: 'GET'
  });
}

/**
 * 删除商品
 * @param pram
 */
export function productDeleteApi(id, type) {
  return request({
    url: "/admin/store/product/delete/".concat(id),
    method: 'get',
    params: {
      type: type
    }
  });
}

/**
 * 商品列表 表头数量
 */
export function productHeadersApi() {
  return request({
    url: '/admin/platform/product/tabs/headers',
    method: 'GET'
  });
}

/**
 * 商品列表
 * @param pram
 */
export function productLstApi(params) {
  return request({
    url: '/admin/platform/product/list',
    method: 'GET',
    params: params
  });
}

/**
 * 商品审核
 * @param pram
 */
export function productAuditApi(data) {
  return request({
    url: "/admin/platform/product/audit",
    method: 'post',
    data: data
  });
}

/**
 * 修改虚拟销量
 * @param pram
 */
export function onChangeSalesApi(data) {
  return request({
    url: "/admin/platform/product/virtual/sales",
    method: 'post',
    data: data
  });
}

/**
 * 商品分类 分类缓存树
 * @param pram
 */
export function productCategoryApi() {
  return request({
    url: '/admin/platform/product/category/cache/tree',
    method: 'GET'
  });
}
/**
 * 商品分类 列表
 * @param pram
 */
export function productCategoryListApi(params) {
  return request({
    url: '/admin/platform/product/category/list',
    method: 'GET',
    params: params
  });
}
/**
 * 商品分类 新增
 * @param pram
 */
export function productCategoryAddApi(data) {
  return request({
    url: '/admin/platform/product/category/add',
    method: 'post',
    data: data
  });
}
/**
 * 商品分类 编辑
 * @param pram
 */
export function productCategoryUpdateApi(data) {
  return request({
    url: '/admin/platform/product/category/update',
    method: 'post',
    data: data
  });
}
/**
 * 商品分类 删除
 * @param pram
 */
export function productCategoryDeleteApi(id) {
  return request({
    url: "/admin/platform/product/category/delete/".concat(id),
    method: 'post'
  });
}
/**
 * 商品分类 修改分类显示状态
 * @param pram
 */
export function productCategoryShowApi(id) {
  return request({
    url: "/admin/platform/product/category/update/show/".concat(id),
    method: 'post'
  });
}

/**
 * 商品上架
 * @param pram
 */
export function putOnShellApi(id) {
  return request({
    url: "/admin/store/product/putOnShell/".concat(id),
    method: 'GET'
  });
}
/**
 * 商品强制下架
 * @param pram
 */
export function offShellApi(data) {
  return request({
    url: "/admin/platform/product/force/down",
    method: 'post',
    data: data
  });
}

/**
 * 商品评论 列表
 * @param pram
 */
export function replyListApi(params) {
  return request({
    url: '/admin/platform/product/reply/list',
    method: 'GET',
    params: params
  });
}
/**
 * 商品评论 新增
 * @param pram
 */
export function replyCreatApi(data) {
  return request({
    url: '/admin/store/product/reply/save',
    method: 'POST',
    data: data
  });
}
/**
 * 商品评论 编辑
 * @param pram
 */
export function replyEditApi(data) {
  return request({
    url: '/admin/store/product/reply/update',
    method: 'POST',
    data: data
  });
}
/**
 * 商品评论 详情
 * @param pram
 */
export function replyInfoApi(id) {
  return request({
    url: "/admin/store/product/reply/info/".concat(id),
    method: 'GET'
  });
}
/**
 * 商品评论 删除
 * @param pram
 */
export function replyDeleteApi(id) {
  return request({
    url: "/admin/platform/product/reply/delete/".concat(id),
    method: 'GET'
  });
}

/**
 * 商品评论 导出
 * @param pram
 */
export function productExportApi(params) {
  return request({
    url: "/admin/export/excel/product",
    method: 'get',
    params: params
  });
}

/**
 * 商品复制 99Api
 * @param pram
 */
export function importProductApi(params) {
  return request({
    url: "/admin/store/product/importProduct",
    method: 'post',
    params: params
  });
}

/**
 * 商品复制 一号通
 * @param pram
 */
export function copyProductApi(data) {
  return request({
    url: "/admin/store/product/copy/product",
    method: 'post',
    data: data
  });
}

/**
 * 商品列表 导出
 * @param pram
 */
export function productExcelApi(params) {
  return request({
    url: "/admin/export/excel/product",
    method: 'get',
    params: params
  });
}

/**
 * 商品列表 获取复制商品配置
 * @param pram
 */
export function copyConfigApi() {
  return request({
    url: "/admin/store/product/copy/config",
    method: 'post'
  });
}

/**
 * 订单数据 导出
 * @param pram
 */
export function orderExcelApi(params) {
  return request({
    url: "/admin/export/excel/order",
    method: 'get',
    params: params
  });
}

/**
 * 品牌 列表
 * @param pram
 */
export function brandListApi(params) {
  return request({
    url: "/admin/platform/product/brand/list",
    method: 'get',
    params: params
  });
}

/**
 * 品牌缓存列表(全部)
 * @param pram
 */
export function brandListAllApi() {
  return request({
    url: "/admin/platform/product/brand/cache/list",
    method: 'get'
  });
}

/**
 * 品牌 新增
 * @param pram
 */
export function brandAddApi(data) {
  return request({
    url: "/admin/platform/product/brand/add",
    method: 'post',
    data: data
  });
}

/**
 * 品牌 编辑
 * @param pram
 */
export function brandUpdateApi(data) {
  return request({
    url: "/admin/platform/product/brand/update",
    method: 'post',
    data: data
  });
}

/**
 * 品牌 删除
 * @param pram
 */
export function brandDeleteApi(id) {
  return request({
    url: "/admin/platform/product/brand/delete/".concat(id),
    method: 'post'
  });
}

/**
 * 品牌 修改品牌显示状态
 * @param pram
 */
export function brandShowApi(id) {
  return request({
    url: "/admin/platform/product/brand/update/show/".concat(id),
    method: 'post'
  });
}

/**
 * 保障服务 列表
 * @param pram
 */
export function guaranteeListApi(params) {
  return request({
    url: "/admin/platform/product/guarantee/list",
    method: 'get',
    params: params
  });
}

/**
 * 保障服务 新增
 * @param pram
 */
export function guaranteeAddApi(data) {
  return request({
    url: "/admin/platform/product/guarantee/add",
    method: 'post',
    data: data
  });
}

/**
 * 保障服务 编辑
 * @param pram
 */
export function guaranteeUpdateApi(data) {
  return request({
    url: "/admin/platform/product/guarantee/update",
    method: 'post',
    data: data
  });
}

/**
 * 保障服务 删除
 * @param pram
 */
export function guaranteeDeleteApi(id) {
  return request({
    url: "/admin/platform/product/guarantee/delete/".concat(id),
    method: 'post'
  });
}

/**
 * 保障服务 修改品牌显示状态
 * @param pram
 */
export function guaranteeShowApi(id) {
  return request({
    url: "/admin/platform/product/guarantee/update/show/".concat(id),
    method: 'post'
  });
}

/**
 * 修改商品
 * @param pram
 */
export function updateProductApi(data) {
  return request({
    url: "/admin/platform/product/update",
    method: 'post',
    data: data
  });
}

/**
 * 商品可用优惠券列表
 * @param pram
 */
export function productCouponListApi() {
  return request({
    url: '/admin/platform/coupon/product/usable/list',
    method: 'get'
  });
}

/**
 * 商品搜索分页列表（活动）
 * @param pram
 */
export function productActivityListApi(params) {
  return request({
    url: '/admin/platform/product/activity/search/page',
    method: 'get',
    params: params
  });
}

/**
 * 根据商品id集合查询商品列表
 * @param pram
 */
export function productListbyidsApi(ids) {
  return request({
    url: "/admin/platform/product/listbyids/".concat(ids),
    method: 'get'
  });
}

/**
 * 商品标签列表
 * @param params 查询参数
 * @returns {*} 查询结果
 */
export function productTagListApi(params) {
  return request({
    url: "admin/platform/producttag/list",
    method: 'get',
    params: _objectSpread(_objectSpread({}, params), {}, {
      keywords: encodeURI(params.keywords)
    })
  });
}

/**
 * 商品标签删除
 * @param id 待删除id
 * @returns {*}
 */
export function productTagDelete(id) {
  return request({
    url: "/admin/platform/producttag/delete/".concat(id),
    method: 'get'
  });
}

/**
 * 商品标签详情
 * @param id
 * @returns {*}
 */
export function productTagInfoApi(id) {
  return request({
    url: "/admin/platform/producttag/info/".concat(id),
    method: 'get'
  });
}

/**
 * 新增商品标签
 * @param data 待新增数据
 * @returns {*} 新增结果
 */
export function productTagAddApi(data) {
  return request({
    url: "admin/platform/producttag/save",
    method: 'post',
    data: data
  });
}

/**
 * 编辑商品标签
 * @param data 待编辑数据
 * @returns {*} 新增结果
 */
export function productTagUpdateApi(data) {
  return request({
    url: "admin/platform/producttag/update",
    method: 'post',
    data: data
  });
}

/**
 * 更新标签状态
 * @param id 标签id
 * @param status 标签状态
 * @returns {*}
 */
export function productTagStatusApi(id, status) {
  return request({
    url: "/admin/platform/producttag/status/".concat(id, "/").concat(status),
    method: 'get'
  });
}

/**
 * 平台端批量商品审核
 * @returns {*}
 */
export function productBatchAuditApi(data) {
  return request({
    url: "/admin/platform/product/batch/audit",
    method: 'post',
    data: data
  });
}

/**
 * 批量设置虚拟销量
 * @returns {*}
 */
export function productBatchVirtualSalesApi(data) {
  return request({
    url: "/admin/platform/product/batch/set/virtual/sales",
    method: 'post',
    data: data
  });
}

// 商品会员配置详情
export function memberVipInfo(productId) {
  return request({
    url: "/admin/platform/product/listAttrValue/".concat(productId),
    method: 'get'
  });
}

// 商品平台会员配置
export function savePlatVip(data) {
  return request({
    url: "/admin/platform/product/listAttrValue/vip/save",
    method: 'post',
    data: data
  });
}

// 商品权益卡配置
export function saveEquityVip(data) {
  return request({
    url: "/admin/platform/product/listAttrValue/save",
    method: 'post',
    data: data
  });
}

// 商品折扣列表
export function queryDiscountList() {
  return request({
    url: "/publicly/platform/product/discount/list",
    method: 'get'
  });
}

// 导入商品平台会员配置
export function importPlatVip(data) {
  return request({
    url: "/admin/platform/product/listAttrValue/importVip/excel",
    method: 'post',
    data: data
  });
}

// 导入商品权益卡配置
export function importEquityVip(data) {
  return request({
    url: "/admin/platform/product/listAttrValue/importBenefits/excel",
    method: 'post',
    data: data
  });
}

/**
 * 药单列表
 * @param pram
 */
export function productMedicineListApi(data) {
  return request({
    url: '/admin/platform/medicine/list/pages',
    method: 'post',
    data: data
  });
}
/**
 * 药单新增
 * @param data
 */
export function productMedicineAddApi(data) {
  return request({
    url: '/admin/platform/medicine/list/save',
    method: 'post',
    data: data
  });
}
/**
 * 药单列表编辑
 * @param pram
 */
export function productMedicineUpdateApi(data) {
  return request({
    url: '/admin/platform/medicine/list/update',
    method: 'post',
    data: data
  });
}
/**
 * 药单详情
 * @param pram
 */
export function productMedicineInfoApi(params) {
  return request({
    url: '/admin/platform/medicine/list/info',
    method: 'get',
    params: params
  });
}
/**
 * 药单删除
 * @param pram
 */
export function productMedicineDeleteApi(id) {
  return request({
    url: "/admin/platform/medicine/list/delete/".concat(id),
    method: 'delete'
  });
}
/**
 * 药单状态修改
 * @param pram
 */
export function productMedicineStatusApi(data) {
  return request({
    url: "/admin/platform/medicine/list/update/status",
    method: 'post',
    data: data
  });
}
/**
 * 药单商品导入
 * @param pram
 */
export function productMedicineImportApi(data) {
  return request({
    url: "/admin/platform/medicine/list/import",
    method: 'post',
    data: data
  });
}

/**
 * 退款订单数据 导出
 * @param pram
 */
export function refundOrderExcelApi(params) {
  return request({
    url: "/admin/platform/export/refundOrder/excel",
    method: 'get',
    params: params
  });
}

/**
 * 商品名称分页列表
 */
export function productListApi(data) {
  return request({
    url: "admin/platform/product/name/list",
    method: 'post',
    data: data
  });
}

/**
 * 商品名称保存
 */
export function productSaveApi(data) {
  return request({
    url: "admin/platform/product/name/save",
    method: 'post',
    data: data
  });
}

/**
 * 商品名称修改
 */
export function productUpdateApi(data) {
  return request({
    url: "admin/platform/product/name/update",
    method: 'post',
    data: data
  });
}

/**
 * 商品名称删除
 */
export function productDelApi(params) {
  return request({
    url: "admin/platform/product/name/delete",
    method: 'get',
    params: params
  });
}

/**
 * 商品名称批量导入
 */
export function productImportApi(data) {
  return request({
    url: "admin/platform/product/name/import",
    method: 'post',
    data: data
  });
}

/**
 * 禁售商品名称分页列表
 */
export function prohibitedListApi(data) {
  return request({
    url: "admin/platform/black/product/name/list",
    method: 'post',
    data: data
  });
}

/**
 * 禁售商品名称保存
 */
export function prohibitedSaveApi(data) {
  return request({
    url: "admin/platform/black/product/name/save",
    method: 'post',
    data: data
  });
}

/**
 * 禁售商品名称修改
 */
export function prohibitedUpdateApi(data) {
  return request({
    url: "admin/platform/black/product/name/update",
    method: 'post',
    data: data
  });
}

/**
 * 禁售商品名称删除
 */
export function prohibitedDelApi(params) {
  return request({
    url: "admin/platform/black/product/name/delete",
    method: 'get',
    params: params
  });
}

/**
 * 禁售商品名称批量导入
 */
export function prohibitedImportApi(data) {
  return request({
    url: "admin/platform/black/product/name/import",
    method: 'post',
    data: data
  });
}

/**
 * 渠道商品库列表
 */
export function channelProductListApi(params) {
  return request({
    url: "admin/platform/channelProduct/list",
    method: 'get',
    params: params
  });
}

/**
 * 添加渠道商品库
 */
export function channelProductAddApi(data) {
  return request({
    url: "admin/platform/channelProduct/add",
    method: 'post',
    data: data
  });
}

/**
 * 导入渠道商品库商品
 */
export function channelProductImportApi(data) {
  return request({
    url: "admin/platform/channelProduct/importProduct",
    method: 'post',
    data: data
  });
}
/**
 * 更新渠道商品库
 */
export function updateChannelProductApi(data) {
  return request({
    url: "admin/platform/channelProduct/update",
    method: 'post',
    data: data
  });
}
/**
 * 删除渠道商品库
 */
export function deleteChannelProductApi(id) {
  return request({
    url: "admin/platform/channelProduct/delete/".concat(id),
    method: 'get'
  });
}
/**
 * 商品库详情
 */
export function channelProductInfoApi(id) {
  return request({
    url: "admin/platform/channelProduct/info/".concat(id),
    method: 'get'
  });
}
/**
 * 商品库商品列表
 */
export function channelProductInfoListApi(id) {
  return request({
    url: "admin/platform/channelProduct/channelProductLibraryProducts/".concat(id),
    method: 'get',
    params: {
      limit: 9999999
    }
  });
}
/**
 * 选项卡组件批量导出
 */
export function exportSelectorApi(data) {
  return request({
    url: "admin/platform/public/page/selector/im/ex/port/export/selector",
    method: 'post',
    data: data,
    responseType: 'blob'
  });
}
/**
 * 商品列表组件批量导出
 */
export function exportNoSelectorApi(data) {
  return request({
    url: "admin/platform/public/page/selector/im/ex/port/export",
    method: 'post',
    data: data,
    responseType: 'blob'
  });
}
/**
 * 选项卡组件批量导入
 */
export function importSelectorApi(data) {
  return request({
    url: "admin/platform/public/page/selector/im/ex/port/import/selector",
    method: 'post',
    data: data
  });
}
/**
 * 商品列表组件批量导入
 */
export function importNoSelectorApi(data) {
  return request({
    url: "admin/platform/public/page/selector/im/ex/port/import",
    method: 'post',
    data: data
  });
}
// 手动触发商品AI审核
export function aiReviewProductApi(data) {
  return request({
    url: "/admin/platform/product/ai/review/".concat(data.productId),
    method: 'post',
    data: data
  });
}